import PanelCollection from '@react-components/Message/PanelCollection';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

(function() {
    let elements = <NodeListOf<HTMLElement>>document.querySelectorAll('[data-panel-collection]');
    let i;
    for (i=0; i < elements.length; i++) {
        let dataUri = elements[i].getAttribute('data-uri');
        ReactDOM.render(
            React.createElement(PanelCollection, {
                uri: dataUri
            }),
            elements[i]);
    }
}());
